"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderFileSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class SalesOrderFileSearchResponse extends common_1.PaginatedResponse {
}
exports.SalesOrderFileSearchResponse = SalesOrderFileSearchResponse;
//# sourceMappingURL=sales-order-file-search.response.js.map